module.exports = __webpack_public_path__ + "static/media/fondo_imitador.af4695ef.jpg";